import { useEffect, useState  } from 'react';
import { Container, Typography, Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Grid, Card, CardContent, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { loadData, saveData, uid } from '../store/data';
import SectionHero from '../components/SectionHero';
import { motion } from 'framer-motion';

export default function CaseStudies() {
  const [data, setData] = useState(loadData());
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ id: '', title: '', summary: '' });

  const openAdd = () => {
    setEditing(null);
    setForm({ id: '', title: '', summary: '' });
    setOpen(true);
  };
  const openEdit = (item) => {
    setEditing(item.id);
    setForm(item);
    setOpen(true);
  };
  const close = () => setOpen(false);

  const save = () => {
    let caseStudies = data.caseStudies || [];
    if (editing) {
      caseStudies = caseStudies.map((i) => (i.id === editing ? form : i));
    } else {
      caseStudies = [...caseStudies, { ...form, id: uid() }];
    }
    const next = { ...data, caseStudies };
    saveData(next);
    setData(next);
    setOpen(false);
  };

  const remove = (id) => {
    const caseStudies = (data.caseStudies || []).filter((i) => i.id !== id);
    const next = { ...data, caseStudies };
    saveData(next);
    setData(next);
  };

  const items = data.caseStudies || [];

  return (
    <>
      <SectionHero
        title="Case Studies"
        subtitle="Real installations, measurable outcomes"
        variant="grid"
      />
      <Container sx={{ py: { xs: 4, md: 6 }, px: { xs: 2, sm: 3 } }}>
        <Box sx={{ display: 'flex', justifyContent: { xs: 'stretch', sm: 'flex-end' }, mb: 2 }}>
          <Button variant="contained" startIcon={<AddIcon />} onClick={openAdd} fullWidth sx={{ maxWidth: { sm: 'none' }, width: { xs: '100%', sm: 'auto' } }}>Add Case Study</Button>
        </Box>
      <Grid container spacing={3} component={motion.div} initial="hidden" animate="show" variants={{ hidden: {}, show: { transition: { staggerChildren: 0.08 }}}}>
        {items.map((it) => (
          <Grid item xs={12} md={6} key={it.id} component={motion.div} variants={{ hidden: { opacity: 0, y: 16 }, show: { opacity: 1, y: 0 }}}>
            <Card component={motion.div} whileHover={{ y: -4 }} transition={{ type: 'spring', stiffness: 300, damping: 22 }}>
              <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 1, flexWrap: 'wrap' }}>
                  <Typography variant="h6" sx={{ fontWeight: 700, flex: 1, minWidth: 0, wordBreak: 'break-word' }}>{it.title}</Typography>
                  <Box>
                    <IconButton onClick={() => openEdit(it)}><EditIcon /></IconButton>
                    <IconButton onClick={() => remove(it.id)}><DeleteIcon /></IconButton>
                  </Box>
                </Box>
                <Typography sx={{ color: 'text.secondary', mt: 1 }}>{it.summary}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Dialog open={open} onClose={close} fullWidth maxWidth="sm">
        <DialogTitle>{editing ? 'Edit Case Study' : 'Add Case Study'}</DialogTitle>
        <DialogContent sx={{ display: 'grid', gap: 2 }}>
          <TextField label="Title" fullWidth value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} />
          <TextField label="Summary" fullWidth multiline rows={4} value={form.summary} onChange={(e) => setForm({ ...form, summary: e.target.value })} />
        </DialogContent>
        <DialogActions>
          <Button onClick={close}>Cancel</Button>
          <Button variant="contained" onClick={save}>Save</Button>
        </DialogActions>
      </Dialog>
    </Container>
    </>
  );
}
